'use strict';

exports.__esModule = true;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spinnerColor = 'rgba(0, 0, 51, 0.3)';
var spinnerColorLight = 'rgba(255, 255, 255, 0.3)';

var spin = (0, _styledComponents.keyframes)(['0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);}to{transform:rotate(360deg);-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);}']);

var Spinner = _styledComponents2.default.div.withConfig({
  displayName: 'Spinner.styled__Spinner'
})(['position:relative;display:', ';width:1em;height:1em;margin:', ';font-size:', ';text-indent:100%;border-radius:0.5em;box-shadow:', ';animation:', ' 1500ms infinite linear;-webkit-animation:', ' 1500ms infinite linear;'], function (p) {
  return p.isShowing ? 'auto' : 'none';
}, function (p) {
  return p.small ? '7px 0 0' : '100px auto 50px';
}, function (p) {
  return p.small ? '4px' : '10px';
}, function (p) {
  var color = p.light ? spinnerColorLight : spinnerColor;
  return '\n      ' + color + ' 1.5em 0 0 0,\n      ' + color + ' 1.1em 1.1em 0 0,\n      ' + color + ' 0 1.5em 0 0,\n      ' + color + ' -1.1em 1.1em 0 0,\n      ' + color + ' -1.5em 0 0 0,\n      ' + color + ' -1.1em -1.1em 0 0,\n      ' + color + ' 0 -1.5em 0 0,\n      ' + color + ' 1.1em -1.1em 0 0;\n    ';
}, spin, spin);

exports.default = Spinner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Spinner/Spinner.styled.js
// module id = 2288
// module chunks = 14